var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27 1.8a1.438 1.438 0 011.988.543l3.303 5.997a1.438 1.438 0 01-1.258 2.152H2.697A1.438 1.438 0 011.439 8.34l3.303-5.997c.124-.224.307-.412.528-.542zM6 3.596a.63.63 0 01.625.66l-.25 3.275H5.62l-.245-3.275A.635.635 0 016 3.595zm-.625 5.221a.625.625 0 111.25-.01.625.625 0 01-1.25.01z",
    fill: "#C50A33"
  })));
}
export default SvgSmall;